import produce from 'immer';
import { get } from 'lodash';

import {
    BannerContentPromotionAction,
    PROMO_CONTENT_URL_SHOW_ERRORS,
    PromoContentUrlShowErrors,
    UPDATE_PROMO_CONTENT_ID,
    UPDATE_PROMO_CONTENT_PREVIEW_URL,
    UPDATE_PROMO_CONTENT_URL,
    UpdatePromoContentId,
    UpdatePromoContentPreviewUrl,
    UpdatePromoContentUrl
} from '../../actions/banners-edit/content-promotion';
import { EditBannersState, getEditedContentPromotionBanner, MassActionId } from '../../typings/bannersEditState';
import { EditBannersInitialState } from '../bannersEdit';

const updatePromoContentUrl = (state: EditBannersState, action: UpdatePromoContentUrl): EditBannersState => {
    return produce(state, draft => {
        const banner = getEditedContentPromotionBanner(draft.banners[action.bannerId]);
        if (!banner) {
            throw new Error('Unsupported banner type');
        }

        banner.contentPromotionUrl.value = action.urlValue;
        banner.contentPromotionUrl.isChecking = true;

        const urlErrors = get(banner, 'errors.contentPromotionUrl');
        if (urlErrors) {
            urlErrors.errors = [];
        }
    });
};

const updatePromoContentId = (state: EditBannersState, action: UpdatePromoContentId): EditBannersState => {
    return produce(state, draft => {
        const banner = getEditedContentPromotionBanner(draft.banners[action.bannerId]);
        if (!banner) {
            throw new Error('Unsupported banner type');
        }

        banner.contentId = action.contentId;
        banner.contentPromotionUrl.isChecking = false;
    });
};

const updatePromoContentPreviewUrl = (
    state: EditBannersState,
    action: UpdatePromoContentPreviewUrl
): EditBannersState => {
    return produce(state, draft => {
        const banner = getEditedContentPromotionBanner(draft.banners[action.bannerId]);
        if (!banner) {
            throw new Error('Unsupported banner type');
        }

        banner.previewUrl = action.previewUrl;
    });
};

const promoContentHrefShowErrors = (state: EditBannersState, action: PromoContentUrlShowErrors): EditBannersState => {
    return produce(state, draft => {
        const banner = getEditedContentPromotionBanner(draft.banners[action.bannerId]);
        if (!banner) {
            throw new Error('Unsupported banner type');
        }
        banner.contentPromotionUrl.isChecking = false;

        banner.errors = {
            ...banner.errors,
            contentPromotionUrl: {
                errors: action.errors
            }
        };
    });
};

export function contentPromotionBannerReducer(
    state: EditBannersState = EditBannersInitialState,
    action: BannerContentPromotionAction
): EditBannersState {
    if (action.bannerId === MassActionId.bannersEdit) {
        return { ...state };
    }
    switch (action.type) {
        case UPDATE_PROMO_CONTENT_URL:
            return updatePromoContentUrl(state, action);
        case PROMO_CONTENT_URL_SHOW_ERRORS:
            return promoContentHrefShowErrors(state, action);
        case UPDATE_PROMO_CONTENT_ID:
            return updatePromoContentId(state, action);
        case UPDATE_PROMO_CONTENT_PREVIEW_URL:
            return updatePromoContentPreviewUrl(state, action);
        default:
            return state;
    }
}
